import { render, staticRenderFns } from "./SimplifiedProposalTable.vue?vue&type=template&id=b3a2ee88&scoped=true"
import script from "./SimplifiedProposalTable.vue?vue&type=script&lang=js"
export * from "./SimplifiedProposalTable.vue?vue&type=script&lang=js"
import style0 from "./SimplifiedProposalTable.vue?vue&type=style&index=0&id=b3a2ee88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a2ee88",
  null
  
)

export default component.exports